import h from "trader-hyperscript";

const s = `
@page {
  size: landscape;
}
nav, aside, header {
  display: none !important;
}
.Planning_slot {
  border: 1px solid grey;
}
`;
export function printStylePlanning() {
  return (
    <style type="text/css" media="print">
      {s}
    </style>
  );
}
